import FlightsClearFiltersBaseController from '../../trains-base/controllers/trains-clear-filters-base-controller';

export default function TrainsClearFiltersController(
    $scope,
    $controller,
    trainsFactory
) {
    'ngInject';

    $controller(FlightsClearFiltersBaseController, {
        $scope,
        trainsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-clear-filters-controller.js